import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsLeadAssignablePipe } from './pipes/is-lead-assignable.pipe';
import { IsLeadOffiablePipe } from './pipes/is-lead-offiable.pipe';
import { IsLeadEditablePipe } from './pipes/is-lead-editable.pipe';
import { IsLeadRejectablePipe } from './pipes/is-lead-rejectable.pipe';

@NgModule({
  declarations: [
    IsLeadAssignablePipe,
    IsLeadOffiablePipe,
    IsLeadEditablePipe,
    IsLeadRejectablePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IsLeadAssignablePipe,
    IsLeadOffiablePipe,
    IsLeadEditablePipe,
    IsLeadRejectablePipe
  ]
})
export class CoreModule { }
